import React, { useState } from "react";
import {
  FiUser,
  FiMail,
  FiPhone,
  FiLock,
  FiEye,
  FiEyeOff,
  FiX,
} from "react-icons/fi";

const API = "https://bodhimaram.onrender.com/api/staff";

const EditProfileModal = ({ profile, setProfile, onClose }) => {
  const [form, setForm] = useState({
    name: profile.name || "",
    email: profile.email || "",
    phone: profile.phone || "",
    role: profile.role || "",
    status: profile.status || "active",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const saveProfile = async () => {
    if (!form.name.trim()) {
      alert("Name is required");
      return;
    }

    if (!form.email.trim()) {
      alert("Email is required");
      return;
    }

    // Password Validation
    if (form.password || form.confirmPassword) {
      if (form.password.length < 6) {
        alert("Password must be at least 6 characters.");
        return;
      }

      if (form.password !== form.confirmPassword) {
        alert("Passwords do not match.");
        return;
      }
    }

    setLoading(true);

    try {
      const payload = {
        name: form.name,
        email: form.email,
        phone: form.phone,
        role: form.role,
        status: form.status,
      };

      // Send password only if entered
      if (form.password.trim() !== "") {
        payload.password = form.password;
      }

      const res = await fetch(`${API}/${profile.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.message || "Update failed");
        setLoading(false);
        return;
      }

      const updatedUser = {
        ...profile,
        ...payload,
      };

      sessionStorage.setItem("user", JSON.stringify(updatedUser));

      setProfile(updatedUser);

      alert("Profile Updated Successfully");

      onClose();
    } catch (err) {
      console.log(err);
      alert("Server Error");
    }

    setLoading(false);
  };

  return (
    <div className="popupOverlay" onClick={onClose}>
      <div
        className="editPopup"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="popupClose" onClick={onClose}>
          <FiX />
        </button>

        <h2>Edit Profile</h2>

        <div className="inputGroup">
          <label>
            <FiUser />
            Full Name
          </label>

          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
          />
        </div>

        <div className="inputGroup">
          <label>
            <FiMail />
            Email
          </label>

          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
          />
        </div>

        <div className="inputGroup">
          <label>
            <FiPhone />
            Phone
          </label>

          <input
            type="text"
            name="phone"
            value={form.phone}
            onChange={handleChange}
          />
        </div>

        <div className="readonlyBox">
          <span>Role</span>
          <strong>
            {profile.role === "admin"
              ? "Administrator"
              : profile.role === "tstaff"
              ? "Teaching Staff"
              : profile.role === "mstaff"
              ? "Management Staff"
              : "Teaching & Management"}
          </strong>
        </div>

        <hr className="profileDivider" />

        <h3 className="passwordTitle">
          Change Password
          <span>(Optional)</span>
        </h3>

        <div className="inputGroup">
          <label>
            <FiLock />
            New Password
          </label>

          <div className="passwordField">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Leave blank to keep current password"
            />

            <button
              type="button"
              className="eyeBtn"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
        </div>

        <div className="inputGroup">
          <label>
            <FiLock />
            Confirm Password
          </label>

          <div className="passwordField">
            <input
              type={showConfirm ? "text" : "password"}
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              placeholder="Re-enter password"
            />

            <button
              type="button"
              className="eyeBtn"
              onClick={() => setShowConfirm(!showConfirm)}
            >
              {showConfirm ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
        </div>

        <div className="popupButtons">
          <button className="cancelBtn" onClick={onClose}>
            Cancel
          </button>

          <button
            className="saveBtn"
            onClick={saveProfile}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditProfileModal;